// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-groups-my-groups__container {
    padding-top: 80px;
}

.page-groups-my-groups__list-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: var(--space);
    column-gap: var(--space);
    grid-row-gap: var(--space);
    row-gap: var(--space);
    /* margin-top: var(--space-x2); */
    margin-bottom: 24px;
}

.page-groups-my-groups__page {
    background: var(--white-color);
    /* box-shadow: 0px 3.02431px 3.02431px rgba(170, 193, 182, 0.32); */
    border-radius: 6px;
    display: flex;
    justify-content: inherit;
    align-items: center;
    padding: 24px;
    cursor: pointer;
    border: 1px solid var(--new-gray-background-color);
}

.page-groups-my-groups__page-photo{
    display: flex;
    align-items: center;
    width: 48px;
    height: 48px;
}

.page-groups-my-groups__page-photo.icon-ball{
    font-size: 40px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    color: var(--white-color);
}

.page-groups-my-groups__page-photo img{
   width: 48px;
   height: 48px;
   border-radius: 50%;
}

.page-groups-my-groups__page-info {
    margin: var(--space-half);  
    cursor: pointer;
}

.page-groups-my-groups__page-info__pagename {
    cursor: pointer;
}

.page-groups-my-groups__page-info__pagetype {
    cursor: pointer;
}

.page-groups-my-groups__page-info__chevron {
    /*align-self: flex-end;*/
    margin-top: var(--space-half-quarter);
    margin-right: var(--space-half);
    flex: 1 1 auto;
    cursor: pointer;
}

.page-groups-my-groups__title.baloa-subtitle-1{
    color: var(--primary-very-dark-color);
}

.page-groups-my-groups__page-info__pagetype.baloa-normal-medium{
    color: var(--primary-very-dark-color);
}

.page-groups-my-groups__page-info__pagename.baloa-names{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .page-groups-my-groups__list-container{
        grid-template-columns:1fr;
        margin-top: 90px;
    }
    .page-groups-my-groups__container {
        margin-top: 0;
        padding: 12px 9px;
    }

    .page-groups-my-groups__page {
        padding: 12px;
        border-radius: 8px;
        border: none;
    }

    .page-groups-my-groups__page-photo {
        width: 39px;
        height: 39px;
    }

    .page-groups-my-groups__page-photo img {
        width: 39px;
        height: 39px;
    }

    .page-groups-my-groups__page-photo.icon-ball {
        font-size: 30px;
        padding: 4px;
    }

    .page-groups-my-groups__page-info {
        margin: 0 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-groups-my-groups/PageGroupsMyGroupsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,0BAA0B;IAC1B,qBAAqB;IACrB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mEAAmE;IACnE,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,+BAA+B;IAC/B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".page-groups-my-groups__container {\n    padding-top: 80px;\n}\n\n.page-groups-my-groups__list-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    grid-column-gap: var(--space);\n    column-gap: var(--space);\n    grid-row-gap: var(--space);\n    row-gap: var(--space);\n    /* margin-top: var(--space-x2); */\n    margin-bottom: 24px;\n}\n\n.page-groups-my-groups__page {\n    background: var(--white-color);\n    /* box-shadow: 0px 3.02431px 3.02431px rgba(170, 193, 182, 0.32); */\n    border-radius: 6px;\n    display: flex;\n    justify-content: inherit;\n    align-items: center;\n    padding: 24px;\n    cursor: pointer;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.page-groups-my-groups__page-photo{\n    display: flex;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n}\n\n.page-groups-my-groups__page-photo.icon-ball{\n    font-size: 40px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    color: var(--white-color);\n}\n\n.page-groups-my-groups__page-photo img{\n   width: 48px;\n   height: 48px;\n   border-radius: 50%;\n}\n\n.page-groups-my-groups__page-info {\n    margin: var(--space-half);  \n    cursor: pointer;\n}\n\n.page-groups-my-groups__page-info__pagename {\n    cursor: pointer;\n}\n\n.page-groups-my-groups__page-info__pagetype {\n    cursor: pointer;\n}\n\n.page-groups-my-groups__page-info__chevron {\n    /*align-self: flex-end;*/\n    margin-top: var(--space-half-quarter);\n    margin-right: var(--space-half);\n    flex: 1 1 auto;\n    cursor: pointer;\n}\n\n.page-groups-my-groups__title.baloa-subtitle-1{\n    color: var(--primary-very-dark-color);\n}\n\n.page-groups-my-groups__page-info__pagetype.baloa-normal-medium{\n    color: var(--primary-very-dark-color);\n}\n\n.page-groups-my-groups__page-info__pagename.baloa-names{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .page-groups-my-groups__list-container{\n        grid-template-columns:1fr;\n        margin-top: 90px;\n    }\n    .page-groups-my-groups__container {\n        margin-top: 0;\n        padding: 12px 9px;\n    }\n\n    .page-groups-my-groups__page {\n        padding: 12px;\n        border-radius: 8px;\n        border: none;\n    }\n\n    .page-groups-my-groups__page-photo {\n        width: 39px;\n        height: 39px;\n    }\n\n    .page-groups-my-groups__page-photo img {\n        width: 39px;\n        height: 39px;\n    }\n\n    .page-groups-my-groups__page-photo.icon-ball {\n        font-size: 30px;\n        padding: 4px;\n    }\n\n    .page-groups-my-groups__page-info {\n        margin: 0 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
